import decode from 'jwt-decode';
import axios from 'axios';


const dbRequests = `http://localhost:5000/auth/verifyadmin`;

class AuthService {
    constructor() {
        this.grabAcoount = this.grabAccount.bind(this);

    }

    userLoggedIn() {
        const token = this.grabToken(); // gets the token from local storage.
        console.log(token)
        return !!token && !this.isTokenExpired(token);
    }


    adminLoggedIn() {
        const token = this.grabToken(); // gets the token from local storage.
        console.log(token)
        return !!token && !this.isTokenExpired(token);
    }

    checkAdminValid () {
    console.log('this is test: ')

        const localJWT = localStorage.getItem('jwt');
        console.log('Component will update: ' + this.state)
          axios
            .get(dbRequests, { headers: { jwt: localJWT } })
            .then(response => {
               return this.setState({ setAdmin: response.data.Admin });
            })
            .catch(err => {
              console.log(err);
            });
    }


    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) {
              // Checking if token is expired.
              return true;
            } else return false;
          } catch (err) {
            return false;
          }
    }

    grabToken() {
        let newItem = localStorage.getItem('jwt');

        return newItem;
    }

    grabAccount(){
        return decode(this.grabToken());
    }

    userLogout() {
        localStorage.removeItem('jwt');
    }
}

export default AuthService;
